import { globalBreak } from "@/styles/break";
import { SxProps } from "@mui/material";

export const pdpStoreStockWishlistSx:SxProps = {
    alignItems:"center",
    justifyContent:globalBreak({mobile:'space-between', desktop:'unset'}),
    columnGap:globalBreak({mobile:'0', desktop:2}),
}

export const PdpProductNameAndDetailsSX:SxProps = {
    py:2.5,
    mr:globalBreak({mobile:'0',desktop:3})
}